define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/form/Widget",
	"csi/html",
	"csi/locale",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Search"
], function(declare,csi,_,Widget,html,locale,Names,xml,Search) {

	return declare(Widget, {
		FIELD_BOM: "BOM",
		FIELD_ALTERNATIVE: "ProductAlternative",
		FIELD_COLOR: "ProductColor",
		FIELD_NAME: "Name",
		FIELD_SIZE: "ProductSize",

		_buildView: function() {
			// summary: set default name and appropriate type for BOM query
			var	product = this._getProduct();
			var	sample = this._getSample();
			var	name = sample.$Name || locale.type("ProductSample");
			
			this.addDefaultValue(this.FIELD_NAME, name + " " + locale.type("ProductBOM"));
			this.addDefaultValue(this.FIELD_ALTERNATIVE, sample.SampleProductAlternative);
			
			this.defView.getField(this.FIELD_BOM).m_relationship.m_typeNode = (this.defView.m_formData.m_node.$Type === "Material") ? "MaterialBOM" : "ApparelBOM";
			
			if (!product.ProductAlternatives.length) {
				this.defView.removeField(this.FIELD_ALTERNATIVE);
			}
			
			this.inherited(arguments);
		},

		_getProduct: function() {
			return this.defView.m_formData.getNode();
		},

		_getSample: function() {
			return this.defView.m_formData.getParent();
		},

		/**
		 * @override
		 * Limit selection of BOMs to ones where ForProductSource is empty or matches Supplier for the Sample
		 */
		getFieldStore: function(field, value) {
			var name = field.getControlName();

			if (name == this.FIELD_BOM) {
				var productSourceNodeURL = this._getSample().__Parent__;
				var search = new Search();
				// Type will be either ApparelBOM or MaterialBOM
				search.byType(field.m_relationship.m_typeNode);
				search.setLimitPath(this._getProduct().$URL, "Child:DataSheets");
				var q = search.getQuery();
				q.Attr("IsSampleBOM", xml.OP_EQUALS, false);
				var qOr = q.Or();
				qOr.RefAttr("ForProductSource", xml.OP_EQUALS, productSourceNodeURL);
				qOr.RefAttr("ForProductSource", xml.OP_EQUALS, "centric:");

				return new Names({
					request: search.getRequest()
				});
			}

			return this.inherited(arguments);
		},

		_onDependency: function(/*Field*/field, /*Field*/fieldSource, /*Any?*/value) {
			// summary: update color/size field visibility
			if (fieldSource.getControlName() == this.FIELD_BOM) {
				var bom = this.cacheView.getNode(fieldSource.getValue(), true);
				if (bom) {
					var	id = field.getControlName();
					var bomRev = this.cacheView.getNode(bom.CurrentRevision, true);
					var	valuesOnBOM = (id == this.FIELD_COLOR)? bomRev.BOMProductColors : bomRev.BOMProductSizes;
					var valueOnSample = this._getSample()[id];
					var	bValid = (_.indexOf(valuesOnBOM, valueOnSample) >= 0);
					if (bValid) {
						value = valueOnSample;
					}
					
					this.setFieldHidden(field, !valuesOnBOM.length);
					html.setDisabled(field.m_control, bValid);
				}
			}
			
			this.inherited(arguments, [field, fieldSource, value]);
		}
	});
});